/** Production API — override with REACT_APP_API_URL for local dev (http://localhost:8000). */
export const API_BASE =
  process.env.REACT_APP_API_URL?.replace(/\/$/, '') ||
  'https://api.gutstring.co'
